module.exports = __webpack_public_path__ + "img/cimb.0913bb48.jpg";